'use client';

import Image from 'next/image';
import type { ReactElement } from 'react';
import Link from 'next/link';

export default function Logo(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-1.5">
      <Link href="/" className="w-fit h-fit">
        <Image
          src="/logo.png"
          width={90}
          height={90}
          alt="logo"
          className="w-16 h-16 rounded-full"
          quality={100}
        />
      </Link>
      <div className="w-fit flex flex-col gap-2">
        <p className="w-fit font-bold text-2xl leading-none">PeacockAI</p>
        <p className="leading-tight font-light text-sm opacity-75 max-w-64">
          Decentralized AI marketplace
        </p>
      </div>
    </div>
  );
}
